export default __webpack_public_path__ + "static/ic_sign_out_modal-9edc2d7592badf579a32da98e3226403.svg";